var exports = {
  "kL": "x04b3a21e--163c88--container",
  "wx": "x04b3a21e--163c88--header",
  "_R": "x04b3a21e--163c88--close-button",
  "rf": "x04b3a21e--163c88--body",
  "pz": "x04b3a21e--163c88--sidebar",
  "h_": "x04b3a21e--163c88--description",
  "UU": "x04b3a21e--163c88--name",
  "FI": "x04b3a21e--163c88--parameters",
  "o1": "x04b3a21e--163c88--actions",
};

module.exports = exports;
